export default "__VITE_ASSET__Dkb$$e4D__"